module.exports = __webpack_public_path__ + "img/38.87a58a41.png";